import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AsYouType, CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { Contact, ContactTitle, Country } from '../../models/models';

@Component({
    selector: 'contact-quick-add',
    templateUrl: './contact-quick-add.component.html',
    standalone: false
})
export class ContactQuickAdd implements OnChanges {
    @Input() contactTitleID: number = 0;
    @Input() tableID: number = 0;
    @Input() contactType: string = "";
    @Input() countryCode: string = "US";
    @Output() onRefreshContact = new EventEmitter<any>();

    public contact: Contact = {} as Contact;
    public contactTitleList: ContactTitle[] = [];
    public countryList: Country[] = [];
    private usPhoneMask: string = "+1 (999) 000-0000";
    private mexicoPhoneMask: string = "52-999-999-9999";
    public phoneMask: string = "+1 (999) 000-0000";
    public cellMask: string = "+1 (999) 000-0000";
    public faxMask: string = "+1 (999) 000-0000";
    public isLoading: boolean = false;

    constructor(private cityService: CityService, private contactService: ContactService) {
    }

    ngOnInit() {
        this.initValues();
        this.getContactTitles();
        this.cityService.getCountriesWithActivePhone().subscribe(result => {
            this.countryList = result.resultCollection;
        });
        //console.log("ngOnInit", this.contact);
    }

    ngOnChanges() {
        //console.log("ngOnChanges", this.contact);
    }

    private initValues() {
        var isDriver: boolean = false;
        if (this.contactTitleID == 3) {
            isDriver = true;
        }
        //if (this.countryCode == "MX") {
        //    this.phoneMask = this.mexicoPhoneMask;
        //}
        //else {
        //    this.phoneMask = this.usPhoneMask;
        //}
        this.contact = this.getNewContact(isDriver);
    }

    private getContactTitles() {
        this.contactService.getContactTitles().subscribe(result => {
            this.contactTitleList = result.resultCollection;
            this.contactTitleList = this.contactTitleList.filter(t => t.contactType.toLocaleLowerCase() == this.contactType.toLocaleLowerCase());
        });
    }

    public phoneCountryChange(evt: any, type: string) {
        var countryID;
        if (!isNaN(evt)) {
            countryID = parseInt(evt);
        }
        else if (evt != null && evt != "" && evt.target) {
            countryID = evt.target.value;
        }
        else {
            return;
        }
        if (type == "cell") {
            this.contact.cell = "";
        }
        else if (type == "phone") {
            this.contact.phone = "";
        }
        this.getPhoneMask(countryID, type);
    }

    public getPhoneMask(countryID: number, type: string) {
        var country = this.countryList.find(t => t.countryId == countryID) as Country;
        var mask = this.usPhoneMask;
        if (country.abbrev.trimEnd() == "MX") {
            mask = this.mexicoPhoneMask;
        }
        if (type == "cell") {
            this.cellMask = mask;
        }
        else {
            this.phoneMask = mask;
        }
    }

    public saveContact() {
        this.isLoading = true;

        if (this.contact.phoneCountryID > 0) {
            var phoneCountry = this.countryList.find(t => t.countryId == this.contact.phoneCountryID)!;
            var phoneType = new AsYouType(phoneCountry.abbrev.trim() as CountryCode);
            phoneType.input(this.contact.phone);
            this.contact.phone = phoneType.getNumber()!.countryCallingCode + phoneType.getNumber()!.nationalNumber;
        }
        if (this.contact.cellCountryID > 0) {
            var cellCountry = this.countryList.find(t => t.countryId == this.contact.cellCountryID)!;
            var cellType = new AsYouType(cellCountry.abbrev.trim() as CountryCode);
            cellType.input(this.contact.cell);
            this.contact.cell = cellType.getNumber()!.countryCallingCode + cellType.getNumber()!.nationalNumber;
        }

        this.contactService.saveContact(this.contact).subscribe(result => {
            this.isLoading = false;
            if (result.contactID > 0) {
                //this.getContacts();
                this.onRefreshContact.emit(result.contactID);
            } else {
                alert('Failed to save Contact');
            }

            this.contact = {} as Contact;
        });
    }

    public cancelContact() {
        this.onRefreshContact.emit();
    }

    public getNewContact(isDriver: boolean) {
        //var newContactType = this.contactType;
        //if (this.contactType.indexOf("Dispatch") >= 0) {
        //    newContactType = "Dispatcher";
        //}
        //else if (this.contactType.indexOf("Driver") >= 0) {
        //    newContactType = "Driver";
        //}
        var newContact = {
            contactType: this.contactType,
            tableID: this.tableID,
            contactTitleID: this.contactTitleID,
            defaultContactInd: false,
            activeInd: true,
            firstName: '',
            lastName: '',
            title: '',
            phone: '',
            phoneExt: '',
            fax: '',
            cell: '',
            email: '',
            erpContactID: 0,
            createDate: new Date(),
            createEmployeeID: parseInt(localStorage.getItem('EmployeeId')!),
            emailBlastIncluded: this.contactType.toLowerCase() == 'customer',
            driverInd: isDriver,
            excludeFromOfferEmailInd: false,
            enteredOfferInd: false
        } as Contact;
        return newContact;
    }
}
